import alliedCircuits from 'assets/images/clients/allied-circuits.png';
import astronics from 'assets/images/clients/astronics.png';
import bestroi from 'assets/images/clients/besroi.png';
import cassioli from 'assets/images/clients/cassioli.png';
import cbiHealth from 'assets/images/clients/cbi-health.png';
import corteseConstructuon from 'assets/images/clients/cortese-construction.png';
import fgf from 'assets/images/clients/fgf.png';
import goodCarbon from 'assets/images/clients/good-carbon.png';
import greenViewTeam from 'assets/images/clients/greenview-team.png';
import kaleidaHealts from 'assets/images/clients/kaleida-health.png';
import morIndustries from 'assets/images/clients/mor-industries.png';
import pattison from 'assets/images/clients/pattison.png';
import pbdWorldwide from 'assets/images/clients/pbd-worldwide.png';
import permaTech from 'assets/images/clients/permatech.png';
import sealDesign from 'assets/images/clients/seal-design.png';
import seneca from 'assets/images/clients/seneca.png';
import westHerr from 'assets/images/clients/west-herr.png';
import wonder from 'assets/images/clients/wonder.png';

const items = [
  cassioli,
  alliedCircuits,
  bestroi,
  morIndustries,
  goodCarbon,
  pattison,
  seneca,
  greenViewTeam,
  cbiHealth,
  astronics,
  sealDesign,
  corteseConstructuon,
  kaleidaHealts,
  permaTech,
  westHerr,
  pbdWorldwide,
  fgf,
  wonder
];

export default items;
